// CONSTANTS are all caps.
const NS = 'QuantityInput';
const CLS = 'quantityInput';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/quantityInput.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class QuantityInput {
	constructor($el) {
		// $el is the widget node return by the loadQuantityInput function
		this.$el = $el;
		this.removeZero = false;
	}

	init() {
		this.checkRemoveZero();
		this.setQuantityInput();
	}

	checkRemoveZero() {
		const removeZero = $(this.$el).attr('remove-zero');
		this.removeZero = typeof removeZero !== 'undefined' && removeZero !== false;
	}

	setQuantityInput() {
		// Add Some logic here
		let This = this;
		let $wg = $(this.$el);
		let $btns = $wg.find('.btn-up, .btn-down');
		let $btnsUp = $wg.find('.btn-up');
		let $btnsDown = $wg.find('.btn-down');

		let $input = $wg.find('input');
		let maxInput = parseInt($input.attr('max'));
		let minInput = parseInt($input.attr('min'));
		let stepInput = parseInt($input.attr('step'));
		let oldValue = $input.val();
		let timeOut = null;

		if (maxInput < 0 ) {
			$input.removeAttr('max');
			maxInput = null;
		}

		function getValidValue(value, min = minInput, max = maxInput) {
			let val = parseInt(value);
			if (isNaN(val)) {
				return minInput;
			}
			if (val < min) {
				val = min;
			}
			if (max && val > max) {
				val = max;
			}
			return val;
		}


		function calcValue(value, max=maxInput, min =minInput, step=stepInput, status ) {
			let val = parseInt(value);
			if (isNaN(val) || (val + stepInput) < minInput) {
				return minInput;
			}

			if ( status == 'increase' && $btnsUp.hasClass('disabled')== true) {
				return val;
			}
			else if ( status == 'increase' && $btnsUp.hasClass('disabled')== false) {
				if (maxInput) {
					val = (val < (maxInput - stepInput)) ? val + stepInput : maxInput;
				} else {
					val = val + stepInput;
				}
			} else {
				val = (val > (minInput + stepInput) ) ? val- stepInput : minInput;
			}
			return val;
		}

		$input.on('keypress', function(e) {
			let code = e.keyCode || e.which;
			// prevent (. , + - e)
			if (code == 46 || code == 44 || code == 43 || code == 45 || code == 101) {
				e.preventDefault();
				return false;
			}
		});

		$input.on('keyup', function(e) {
			This.checkRemoveZero();
			let code = e.keyCode || e.which;
			if (code == 40) {
				$(this).val(calcValue(oldValue, maxInput, minInput, stepInput, 'decrease' ));
				oldValue = $input.val();
				$(this).trigger('change');
			}
			if (code == 38) {
				$(this).val(calcValue(oldValue, maxInput, minInput, stepInput, 'increase' ));
				oldValue = $input.val();
				$(this).trigger('change');
			}
			oldValue = $input.val();
			if (oldValue<= maxInput) {
				$btnsUp.removeClass('disabled');
			}
			if (oldValue >= minInput) {
				$btnsDown.removeClass('disabled');
			}
		});

		$input.on('blur', function() {
			This.checkRemoveZero();
			timeOut =	setTimeout(function() {
				$(this).val(getValidValue(parseInt($(this).val()), minInput, maxInput));
				if (getValidValue(parseInt($(this).val())) <= maxInput) {
					$btnsUp.removeClass('disabled');
				}
				if (getValidValue(parseInt($(this).val())) >= minInput) {
					$btnsDown.removeClass('disabled');
				}
				$(this).trigger('change');
			}.bind(this), 200);
		});

		$btns.on('click', function(e) {
			This.checkRemoveZero();
			clearTimeout(timeOut);
			if($(this).hasClass('disabled')) {
				e.stopPropagation();
				return;
			};

			let currentVal = $input.val();
			if ($(this).hasClass('btn-up')) {
				$input.val(calcValue(currentVal, maxInput, minInput, stepInput, 'increase' ));
				let incr = $input.val();
				if (parseInt(incr) === maxInput) {
					$(this).addClass('disabled');
				}
				if ($btnsDown.hasClass('disabled')) {
					$btnsDown.removeClass('disabled');
				}
				if ($btnsDown.hasClass('zero')) {
					$btnsDown.removeClass('zero');
				}
			} else {
				let decr = $input.val();
				if (parseInt(decr) === 1 && This.removeZero) {
					$(this).addClass('zero');
				}

				$input.val(calcValue(currentVal, maxInput, minInput, stepInput, 'decrease' ));
				decr = $input.val();

				if (parseInt(decr) === minInput && !This.removeZero) {
					$(this).addClass('disabled');
				}
				if ($btnsUp.hasClass('disabled')) {
					$btnsUp.removeClass('disabled');
				}
			}

			$input.trigger('change');
		});

		// on load, check the max and min is not reached
		if (parseInt(oldValue) === minInput && !This.removeZero) {
			$btnsDown.addClass('disabled');
		}
		if (parseInt(oldValue) === 1 && This.removeZero) {
			$btnsDown.addClass('zero');
		}
		if (parseInt(oldValue) === maxInput) {
			$btnsUp.addClass('disabled');
		}
	}

	// Add more functions like on above here
}

export const updateQuantity = ($element, {remove, quantity}) => {
	if (quantity){
		$element.find('input').val(quantity);
	}
	const value = $element.find('input').val();
	if (remove) {
		$element.attr('remove-zero', true);
		if (value == 1) {
			$element.find('.btn-down').removeClass('disabled').addClass('zero');
		}
	} else {
		$element.removeAttr('remove-zero');
		if (value == 1) {
			$element.find('.btn-down').removeClass('zero').addClass('disabled');
		} else {
			$element.find('.btn-down').removeClass('disabled');
		}
	}
};



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_06/_work/151/s/FrontEnd/src/views/widgets/quantityInput/js/quantityInput.js